<template>
  <div :class="containerClass">
    <div style="display: center">
      <div class="flex" :class="isTabSmallScreen ? 'px-2' : 'px-3'">
        <div class="row" style="align-items: center;">
          <h2 class="" :class="isTabSmallScreen ? 'h4' : ''">
            New Skill Card
          </h2>
          <!-- <b-btn class="mb-3" variant="primary">Generate</b-btn> -->
        </div>
      </div>
      <div class="card" :class="isTabSmallScreen ? 'mx-2' : ''">
        <div class="card-body" :class="isTabSmallScreen ? 'p-2' : ''">
          <b-tabs
            v-model="activeTab"
            nav-class="nav-tabs-card bg-white disable-tab-clicks"
            :class="isTabSmallScreen ? 'px-1' : 'px-3'"
            content-class=" "
            class="mt-0"
            id="skillmapTabs"
            @input="onTabsChanged"
            :style="isTabSmallScreen ? 'scroll-margin-top: 66px; font-size: 14px;' : 'scroll-margin-top: 66px; font-size: 16.5px;'"
          >
            <b-tab title="SCENARIO DETAILS" class="tab-secondary">
              <template #title>
                <i class="fas fa-file-alt align-self-center" :class="isTabSmallScreen ? 'mx-2' : 'mx-1'"></i>
                <strong class="ml-1" v-if="!isTabSmallScreen">SCENARIO DETAILS</strong>
              </template>
              <div :class="isTabSmallScreen ? 'p-2' : 'p-3'">
                <scenario-detail-form :onNext="onTabsChanged" />
              </div>
            </b-tab>
            <b-tab title="COMPETITION" class="tab-secondary">
              <template #title>
                <i class="fas fa-trophy align-self-center" :class="isTabSmallScreen ? 'mx-2' : 'mx-1'"></i>
                <strong class="ml-1" v-if="!isTabSmallScreen">COMPETITION</strong>
              </template>
              <div :class="isTabSmallScreen ? 'p-2' : 'p-3'">
                <competition-selection-form :myIndex="1" :onNext="onTabsChanged" :activeTabIndex="activeTab" />
              </div>
            </b-tab>
            <b-tab title="ANCHOR ELEMENTS" class="tab-secondary">
              <template #title>
                <i class="fas fa-anchor align-self-center" :class="isTabSmallScreen ? 'mx-2' : 'mx-1'"></i>
                <strong class="ml-1" v-if="!isTabSmallScreen">ANCHOR ELEMENTS</strong>
              </template>
              <div :class="isTabSmallScreen ? 'p-2' : 'p-3'">
                <anchor-elements-form :myIndex="2" :onNext="onTabsChanged" :activeTabIndex="activeTab" />
              </div>
            </b-tab>
                         <b-tab title="PROMPT / IMAGE" class="tab-secondary">
               <template #title>
                 <i class="fas fa-image align-self-center" :class="isTabSmallScreen ? 'mx-2' : 'mx-1'"></i>
                 <strong class="ml-1" v-if="!isTabSmallScreen">PROMPT / IMAGE</strong>
               </template>
               <div :class="isTabSmallScreen ? 'p-2' : 'p-3'">
                 <prompt-image-form :myIndex="3" :activeTabIndex="activeTab" />
               </div>
             </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ScenarioDetailForm from './ScenarioDetailForm.vue';
import PromptImageForm from './PromptImageForm.vue';
import AnchorElementsForm from './AnchorElementsForm.vue';
import CompetitionSelectionForm from './CompetitionSelectionForm.vue';
import Page from '@/components/Page.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SkillMapForm',
  extends: Page,
  components: { ScenarioDetailForm, PromptImageForm, AnchorElementsForm, CompetitionSelectionForm },
  props: {},
  data() {
    return {
      activeTab: 0,
      windowWidth: window.innerWidth,
      skillmap: {
        program: '',
        skillStep: '',
        race: '',
        gender: '',
        actorAge: '',
        uniformType: '',
        uniformColor: '',
        patientAge: '',
        patientCondition: '',
        patientPosition: '',
        envSetting: '',
        roomType: '',
        timeDay: '',
        sceneMood: '',
        competition: '',
      },
    };
  },
  computed: {
    ...mapState('aiSkills', ['skillCard']),
    isTabSmallScreen() {
      return this.windowWidth <= 767;
    },
  },
  watch: {
    skillmap: {
      handler(newValue) {
        this.$emit('update:formData', newValue);
      },
      deep: true,
    },
    formData: {
      handler(newValue) {
        this.skillmap = JSON.parse(JSON.stringify(newValue));
      },
      deep: true,
    },
    skillCard: {
      handler(newValue) {
        this.skillmap = { ...this.skillmap, ...newValue };
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('aiSkills', ['setSkillCardValues']),
    
    onTabsChanged(index) {
      this.activeTab = index;
    },
    goBack() {
      this.$router.go(-1);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="css">
.disable-tab-clicks li.nav-item > a.nav-link {
  pointer-events: none;
}

/* Icon color for active tab */
.nav-tabs-card .nav-link.active i {
  color: var(--secondary) !important;
}

/* Try targeting Bootstrap Vue generated classes */
/* .nav-tabs .nav-item .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important;
}

.nav-tabs-card .nav-item .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important;
}

.nav-tabs .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important;
} */

/* More specific targeting for the skillmap tabs */
/* #skillmapTabs .nav-tabs .nav-item .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important; */
/* } */

/* #skillmapTabs .nav-tabs .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important;
} */

/* Global approach */
/* .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important;
} */

/* Bootstrap Vue specific */
/* .tab-content .nav-tabs .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important;
} */

/* Try targeting the card specifically */
/* .card .nav-tabs .nav-link.active {
  border-bottom: 3px solid var(--secondary) !important;
} */
</style>
